import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

const BASE_PATH = "/internal_api/circle_ai/bots";
const TRIGGER_TYPES_PATH = "/internal_api/circle_ai/bot_trigger_types";

export const circleAiBots = {
  schedule: ({ botId }: { botId: number }) =>
    buildPath(`${BASE_PATH}/${botId}/schedule`),
  triggerTypes: () => buildPath(TRIGGER_TYPES_PATH),
  triggers: ({ botId }: { botId: number }) =>
    buildPath(`${BASE_PATH}/${botId}/triggers`),
  trigger: ({ botId, id }: { botId: number; id: string }) =>
    buildPath(`${BASE_PATH}/${botId}/triggers/${id}`),
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath(BASE_PATH, params),
  show: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}`),
  create: () => buildPath(BASE_PATH),
  update: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}`),
  destroy: ({ id }: { id: number }) => buildPath(`${BASE_PATH}/${id}`),
  completions: ({ botId }: { botId: number }) =>
    buildPath(`${BASE_PATH}/${botId}/completions`),
  conversations: ({ botId, params = {} }: { botId: number; params?: Params }) =>
    buildPath(`${BASE_PATH}/${botId}/conversations`, params),
};
